import { createSlice } from '@reduxjs/toolkit'
import _, { sum } from 'lodash'
import { FOOD_TYPES } from '~/constants/buffet'

/**
 * Handle event thêm món ăn vào giỏ hàng
 * @param {*} state
 * @param {*} action
 */
const handleAddItemsToCart = (state, action) => {
  const addedItem = action.payload
  const { primaryKey, quantity } = addedItem
  const { data: itemsInCart } = state

  // Tìm món ăn được thêm vào đã có trong giỏ hàng chưa, nếu đã tồn tại thì cộng dồn quantity lại
  const currrentItemIndex = itemsInCart.findIndex((item) => item.primaryKey === primaryKey)

  if (currrentItemIndex >= 0) {
    const currentItem = itemsInCart[currrentItemIndex]
    currentItem.quantity = currentItem.quantity + quantity
  } else {
    itemsInCart.unshift(action.payload)
  }
}

const initialState = {
  data: [],
  restaurant_cart: {},
  voucher: {
    code: '',
    value: 0,
  },
}

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addItemToCart: handleAddItemsToCart,
    // Hàm xử lý mỗi lần add món ăn thì lưu thông tin nhà hàng lên cart
    addRestaurantToCart: (state, action) => {
      const { id, name, vatPercent, serviceRate } = action.payload

      state.restaurant_cart[id] = {
        name,
        vatPercent,
        serviceRate,
      }
    },
    // Hàm xử lý thêm voucher vào giỏ hàng
    addVoucherToCart: (state, action) => {
      state.voucher = action.payload
    },
    // Hàm xử lý xoá voucher khỏi giỏ hàng
    removeVoucherFromCart: (state) => {
      state.voucher = {}
    },
    changeQuantityItemCart: (state, action) => {
      const { primaryKey, numQuantity } = action.payload
      const currentItemCart = state.data.find((itemCart) => itemCart.primaryKey === primaryKey)

      currentItemCart.quantity += numQuantity
    },
    removeItemCart: (state, action) => {
      state.data = state.data.filter((itemCart) => itemCart.primaryKey !== action.payload)
    },
    removeItemCartById: (state, action) => {
      const { food_item_id, topping_id } = action.payload
      if (food_item_id) {
        if (topping_id) {
          state.data = state.data.filter((itemCart) => {
            const listIdTopping = []
            itemCart.foodOptionTypes.forEach((item) => {
              item.foodOptions.forEach((option) => {
                listIdTopping.push(option.id)
              })
            })

            return !listIdTopping.includes(topping_id)
          })
          return
        }
        state.data = state.data.filter((itemCart) => itemCart.id !== food_item_id)
      }
    },
    // Hàm giảm món ăn trong popup recommend menu
    handleDecreaseFoodInRecommend: (state, action) => {
      const foodId = action.payload.foodId
      const { data: itemsInCart } = state
      // Tìm món ăn trong giỏ hàng
      const currrentItemIndex = itemsInCart.findIndex((item) => item.id === foodId)

      if (currrentItemIndex >= 0) {
        // Xử lý trong trường hợp
        const currentItem = itemsInCart[currrentItemIndex]
        if (currentItem.quantity <= 1) {
          state.data.splice(currrentItemIndex, 1) // xoá phần tử đầu tiên tìm thấy
        } else {
          currentItem.quantity = currentItem.quantity - 1
        }
      }
    },
    // Hàm tăng số lượng món ăn trong trường hợp không có topping thì cộng trực tiếp luôn
    handleIncreaseFoodInRecommend: (state, action) => {
      const foodId = action.payload.foodId
      const { data: itemsInCart } = state
      const currrentItemIndex = itemsInCart.findIndex((item) => item.id === foodId)

      if (currrentItemIndex >= 0) {
        const currentItem = itemsInCart[currrentItemIndex]
        currentItem.quantity += 1 // tăng thêm một số lượng
      }
    },
    clearAllCart: (state) => {
      state.data = []
      state.restaurant_cart = {}
      state.voucher = {}
    },
  },
})

export const {
  addItemToCart,
  changeQuantityItemCart,
  removeItemCart,
  removeItemCartById,
  clearAllCart,
  addRestaurantToCart,
  addVoucherToCart,
  removeVoucherFromCart,
  handleDecreaseFoodInRecommend,
  handleIncreaseFoodInRecommend,
} = cartSlice.actions

/**
 * Lấy tổng số lượng item trong giỏ hàng
 * @param {*} state
 * @returns {number}
 */
export const selectTotalQuantity = (state) => {
  const items = state.cart.data
  if (items.length === 0) return 0

  return sum(items.map((item) => item.quantity))
}

export const dataCartSelector = (state) => state.cart.data

// Lấy thông tin nhà hàng được lưu trong giỏ hàng
export const dataRestaurantFromCartSelector = (state) => state.cart.restaurant_cart

export default cartSlice.reducer

/* Tính tổng tiền chi tiết topping */
const totalMoneyDetailTopping = (foodOptions) => {
  if (!Array.isArray(foodOptions)) return 0

  return foodOptions.reduce((total, currTopping) => {
    const { price, quantity } = currTopping
    return total + (quantity || 1) * (price || 0)
  }, 0)
}

/* Tính tổng tiền topping type */
const totalMoneyTopping = (toppingTypes) => {
  if (!Array.isArray(toppingTypes)) return 0
  return toppingTypes.reduce((total, currTopping) => {
    const { foodOptions } = currTopping
    return total + totalMoneyDetailTopping(foodOptions)
  }, 0)
}

/* Tính tổng tiền của một món ăn: (giá gốc + tổng tiền topping) * số lượng  */
export const totalMoneyItemCart = (itemcart) => {
  const { price, foodOptionTypes, quantity } = itemcart
  return (price + totalMoneyTopping(foodOptionTypes)) * quantity
}

/* Tổng tiển của tất cả item trong giỏ hàng. */
export const totalMoneyItemsCartSelector = (state) => {
  return state.cart.data.reduce((total, currValue) => {
    return total + totalMoneyItemCart(currValue)
  }, 0)
}

/** Tính giá 1 món ăn  : (giá gốc + tổng tiền topping )*/
export const priceTotalItemCart = (itemcart) => {
  const { price, foodOptionTypes } = itemcart
  return price + totalMoneyTopping(foodOptionTypes)
}

/** Tính tổng VAT của món chính
 * giá food * vate_rate
 */
export const amountVATMainFood = (itemcart) => {
  const { vat_rate = 0, price = 0 } = itemcart
  const vatRate = vat_rate / 100 || 0
  return vatRate * price
}

/** Tính tổng VAT của topping
 * giá toppìng * vate_rate topping * quantity topping
 */
export const amountVATTopping = (itemcart) => {
  const { foodOptionTypes } = itemcart
  if (!Array.isArray(foodOptionTypes)) return 0
  return foodOptionTypes.reduce((total, currToppingType) => {
    const { foodOptions } = currToppingType
    const totalVatTopping = foodOptions.reduce((total, currTopping) => {
      const { price = 0, quantity = 1, vat_rate = 0 } = currTopping
      return total + quantity * price * (vat_rate / 100)
    }, 0)
    return total + totalVatTopping
  }, 0)
}

/** Tính VAT 1 món ăn :
 * (VAT món chính + VAT topping) * quantity món ăn
 * do VAT món chính có thể khác VAT topping (ví dụ NEC)
 * */
export const amountVATItemCart = (itemcart) => {
  const { quantity = 1 } = itemcart
  return (amountVATMainFood(itemcart) + amountVATTopping(itemcart)) * quantity
}

/** Tổng tiển VAT từ vat_rate riêng lẻ của từng món ăn
 * ex: Loop có VAT khác nhau cho món ăn khác nhau
 */
export const totalVAT = (state) => {
  return state.cart.data.reduce((totalVAT, currValue) => {
    return totalVAT + amountVATItemCart(currValue)
  }, 0)
}

// Hàm lấy ra voucher có trong cart
export const selectVoucherFromCart = (state) => state.cart.voucher

// Lấy ra số lượng buffet dish đã được add trong giỏ hàng. Chỗ này sẽ không tính số lượng của từng item (Chỉ đếm xem có bao nhiêu món buffet)
export const selectQuantityBuffetDishCart = (state) =>
  state.cart.data.filter((item) => item.food_type === FOOD_TYPES.buffet_dish).length

// Hàm tính tổng số lượng của món ăn dựa vào id. Bên trong giỏ hàng
export const calcTotalQuantityByFoodID = (dataCart = [], foodId) => {
  // Lọc ra các món ăn có foodId tương ứng
  const filteredItems = _.filter(dataCart, { id: foodId })

  // Tính tổng số lượng của các món đó
  const totalQuantity = _.sumBy(filteredItems, 'quantity') || 0

  // Trả về tổng số lượng của món có foodId được cung cấp
  return totalQuantity
}

// Hàm kiểm tra món ăn đó có topping hay không?
export const checkFoodItemHasTopping = (dataCart = [], foodId) => {
  const itemFood = dataCart.find((item) => item.id === foodId)

  if (itemFood) {
    if (itemFood.foodOptionTypes.length > 0) return true

    return false
  }

  return false
}

// Kiểm tra có món ăn recommend trong giỏ hàng hay không. Trả về true là có trong mảng
export const checkFoodRecommendInCart = (dataCart = [], recommendItems) => {
  const check = dataCart.some((itemCart) => {
    const index = recommendItems.findIndex((item) => item.id === itemCart.id)
    return index >= 0
  })

  return check
}
